import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { HeaderBar } from '../../component/HeaderBar'
import { Table } from '../../component/tablePagination'
import { ACCOUNT_LOCK_MESSAGE, ETR_STATUS } from '../../constants'
import { DocumentModel } from '../../models/document'
import * as transactionActions from '../../redux/actions/transaction.action'
import * as editActions from '../../redux/actions/transaction.edit.action'
import { RootReducers } from '../../redux/reducers'
import './style.css'

import userId from '../../assets/images/Uniqe.svg'
import create from '../../assets/images/create.svg'
import search from '../../assets/images/search.svg'
import success from '../../assets/images/success.svg'
import user from '../../assets/images/use.svg'

import { LoadingOverlay } from '../../component/loadingOverlay'
import { AgingModal } from '../../component/modaldialog/ModalAging'
import { CancelModal } from '../../component/modaldialog/ModalCancel'
import { ConfirmModal } from '../../component/modaldialog/ModalConfirmPaid'
import { isBranchStaff } from '../../helpers/roles'
import store from '../../helpers/store'
import { CancelModalModel, ConfirmModalModel } from '../../models/component'
import ModalTransferComplete from '../../component/modaldialog/ModalTransferComplete'
import { getDocumentAging } from '../../redux/actions/document.action'
import { setError } from '../../redux/actions/error.action'

store.setState('showAgingPopup', true)

export const Dashboard: React.VFC = () => {
  // const dispatch = useAppDispatch();
  const itemsPerPage = 10
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const listTransaction = useSelector((state: RootReducers) => state.transactionReducer)
  const loginState = useSelector((state: RootReducers) => state.loginReducer)
  const [transactonDatas, setTransactonDatas] = useState<DocumentModel[]>()
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false)
  const [statusCheckboxes, setStatusCheckboxes] = useState({
    New_ETR: true,
    Cancel_ETR: true,
    Submitted_ETR: true,
    Success_ETR: true
  })
  const [textCancel, setTextCancel] = useState<string>('')
  const [cancelId, setCancelId] = useState<number>(0)
  const [selectETRNo, setSelectETRNo] = useState<string>('')
  const [textRequire, setTextRequire] = useState<string>('')
  const [searchText, setSearchText] = useState('')
  const [page, setPage] = useState(1)
  const [isOpenConfirmModal, setIsOpenConfirmModal] = useState<boolean>(false)
  const [isOpenTransferCompleteModal, setIsOpenTransferCompleteModal] = useState<boolean>(false)
  const [isOpenAgingPopup, setIsOpenAgingPopup] = useState<boolean>(false)
  const [confirmData, setConfirmData] = useState<ConfirmModalModel>({
    eTRNo: '',
    id: 0,
    reasonText: ''
  })
  const [cancelData, setCancelData] = useState<CancelModalModel>({
    eTRNo: '',
    id: 0,
    reasonText: ''
  })

  const [showAgingPopup, setshowAgingPopup] = store.useState('showAgingPopup')
  const [isFetchingAging, setIsFetcingAging] = useState(false)
  const [isAccountLock, setIsAccountLock] = useState(false)

  const searchData = () => {
    dispatch(
      transactionActions.getTransactions(
        loginState.account?.agentInfo.agentId as string,
        loginState.account?.agentInfo.isAO as boolean,
        loginState.account?.agentInfo.isBranchStaff as boolean,
        page,
        itemsPerPage,
        encodeURIComponent(searchText),
        getStatusCheckbox()
      )
    )
  }

  const fetchData = () => {
    if (loginState.account?.agentInfo.agentId) searchData()
  }

  const handleSearchList = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPage(1)
    setSearchText(event.target.value)
  }

  const handleCanceldialog = () => {
    setIsOpenModal(!isOpenModal)
  }

  const handleModalCancel = (id: number, eTRNo: string) => {
    console.log(`id = ${id} | eTRNo = ${eTRNo}`)
    setIsOpenModal(!isOpenModal)
    setCancelData({ id: id, eTRNo: eTRNo, reasonText: '' })
  }

  const handleConfrimStatus = (id: number, eTRNo: string) => {
    setIsOpenConfirmModal(!isOpenConfirmModal)
    setConfirmData({ id: id, eTRNo: eTRNo, reasonText: '' })

    console.log(`id = ${id} | eTRNo = ${eTRNo}`)
  }

  const handleOpenTransferCompleteModal = (id: number, eTRNo: string) => {
    setIsOpenTransferCompleteModal(!isOpenTransferCompleteModal)
    setConfirmData({ id: id, eTRNo: eTRNo, reasonText: '' })

    console.log(`id = ${id} | eTRNo = ${eTRNo}`)
  }

  // const handleTextCancel = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
  //   const { value: text } = event.target
  //   setTextCancel(text)
  // }

  const handleCancelOkButton = (data: CancelModalModel) => {
    const date = new Date()
    if (data.reasonText.length > 0) {
      const docData: DocumentModel = {
        id: data.id,
        status: ETR_STATUS.CANCEL_ETR,
        remark: data.reasonText,
        updateBy: loginState.account?.agentInfo.userName
          ? loginState.account?.agentInfo.userName
          : loginState.account?.agentInfo.agentId,
        canceldate: new Date(
          Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes()
          )
        )
      }
      dispatch(editActions.cancelTransaction(data.id, docData, navigate))
      setCancelId(0)
      setTextCancel('')
      setIsOpenModal(false)
      navigate('/summary', {
        state: {
          message: `ยกเลิกใบรับเงินชั่วคราว<br/>
        <b>หมายเลข ${selectETRNo}</b><br/>
        เรียบร้อยแล้ว`,
          icon: success
        }
      })
      setSelectETRNo('')
    } else {
      setTextRequire('กรุณาระบุเหตุผลในการยกเลิก')
    }
  }

  const handleModalConfirmCancelButton = () => {
    setIsOpenConfirmModal(false)
  }

  const handleCloseTransferCompleteModal = () => {
    setIsOpenTransferCompleteModal(false)
  }

  const handleisAgingPopupOk = () => {
    setIsOpenAgingPopup(!isOpenAgingPopup)
    setshowAgingPopup(false)
    setIsAccountLock(false)
  }

  // const getResultList = () => {
  //   if (searchText.length > 0) return transactonDatas as any[]
  //   else return listTransaction.result?.data as any[]
  // }

  const handlePageClick = (page: number) => {
    console.log(`page = ${page}`)

    setPage(page)
    //setEndOffset(endOffset)
    dispatch(
      transactionActions.getTransactions(
        loginState.account?.agentInfo.agentId as string,
        loginState.account?.agentInfo.isAO as boolean,
        loginState.account?.agentInfo.isBranchStaff as boolean,
        page,
        itemsPerPage,
        encodeURIComponent(searchText),
        getStatusCheckbox()
      )
    )
  }

  const canIssueNewETR = () => {
    if (isBranchStaff(loginState.account?.agentInfo.role as string)) return true
    else if (loginState.account?.agentInfo.isBranchStaff === false) {
      return !loginState.account?.agentInfo.accountLock
    }
    return false
  }

  const displayAccountLockMessage = () => {
    if (loginState.account?.agentInfo.isBranchStaff === false) {
      return !loginState.account?.agentInfo.accountLock
    }
    return true
  }

  const handleCheckboxChange = (event: any) => {
    const { name, checked } = event.target
    setStatusCheckboxes({
      ...statusCheckboxes,
      [name]: checked
    })
  }

  const getStatusCheckbox = () => {
    const selectedOptions = Object.keys(statusCheckboxes).filter(key => statusCheckboxes['New_ETR'])
    const result: string[] = []
    if (statusCheckboxes.New_ETR) result.push('New_ETR')
    if (statusCheckboxes.Cancel_ETR) result.push('Cancel_ETR')
    if (statusCheckboxes.Success_ETR) result.push('Success_ETR')
    if (statusCheckboxes.Submitted_ETR) result.push('Submitted_ETR')
    console.log(result.toString())
    return result.toString()
  }

  const isCanIssueNewETR = canIssueNewETR()
  const handleGetDocumentAging = async () => {
    if (isBranchStaff(loginState.account?.agentInfo.role as string)) {
      navigate('/entryform')
      return
    }

    try {
      setIsFetcingAging(true)
      const data = await dispatch(getDocumentAging())
      if (data.length > 0) {
        setIsAccountLock(true)
        setIsOpenAgingPopup(true)
      } else {
        navigate('/entryform')
      }
    } catch (error) {
      dispatch(setError(error))
    } finally {
      setIsFetcingAging(false)
    }
  }

  useEffect(() => {
    if (loginState.account?.agentInfo.documentAging && showAgingPopup > 0) {
      setIsOpenAgingPopup(true)
    }
    const delayDebounceFn = setTimeout(() => {
      fetchData()
    }, 500)
    return () => clearTimeout(delayDebounceFn)
  }, [searchText, statusCheckboxes])

  return (
    <div>
      {isFetchingAging && <LoadingOverlay />}
      <HeaderBar>
        <div className="header-bar-text-header">ข้อมูลตัวแทน</div>
        <div className="agent-info">
          <div className="row-agent-info">
            <img src={user} alt="user" />
            <div className="agent-text-info">{loginState.account?.agentInfo.name}</div>
          </div>
          <div className="row-agent-info">
            <img src={userId} alt="userId" />
            <div className="agent-text-info">{loginState.account?.agentInfo.agentId}</div>
          </div>
        </div>
      </HeaderBar>
      <div className="container">
        <div className="container-option-bar">
          <div className="button-create-receipt">
            <div className="tooltip">
              <button
                className={`link-create-receipt ${isCanIssueNewETR ? '' : ' not-active'}`}
                onClick={handleGetDocumentAging}
                disabled={isFetchingAging}
              >
                <img src={create} alt="create" />
                ออกใบรับเงินชั่วคราวใหม่
              </button>
              <span
                className={`${displayAccountLockMessage() ? 'hide ' : 'account_lock_tooltiptext'}`}
              >
                {ACCOUNT_LOCK_MESSAGE}
              </span>
            </div>
          </div>
          <div className="search-table">
            <img src={search} alt="search" style={{ position: 'absolute', right: 0 }} />
            <input
              className="search-table-input"
              placeholder="ค้นหา(เลขที่ใบรับเงิน,ชื่อ-นามสกุล,วันที่ออกใบรับเงิน ...)"
              onChange={e => {
                handleSearchList(e)
              }}
              title="ค้นหา(เลขที่ใบรับเงินชั่วคราว,วันที่ออกใบรับเงินชั่วคราว,ชื่อ-นามสกุลผู้เอาประกัน,เลขที่กรมธรรม์,ตัวแทนผู้ออกใบรับเงินชั่วคราว)"
            />
          </div>
        </div>
        <div className="container-option-bar">
          <div></div>
          <div className="container-search-status-bar">
            <ul className="list-search-status">
              <li>
                <input
                  type="checkbox"
                  id="New_ETR"
                  name="New_ETR"
                  checked={statusCheckboxes.New_ETR}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="New_ETR">รายการใหม่</label>
              </li>
              <li>
                <input
                  type="checkbox"
                  id="Cancel_ETR"
                  name="Cancel_ETR"
                  checked={statusCheckboxes.Cancel_ETR}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="Cancel_ETR">ยกเลิก</label>
              </li>
              <li>
                <input
                  type="checkbox"
                  id="Submitted_ETR"
                  name="Submitted_ETR"
                  checked={statusCheckboxes.Submitted_ETR}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="Submitted_ETR">รอดำเนินการ</label>
              </li>
              <li>
                <input
                  type="checkbox"
                  id="Success_ETR"
                  name="Success_ETR"
                  checked={statusCheckboxes.Success_ETR}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="Success_ETR">นำส่งบริษัทสำเร็จ</label>
              </li>
            </ul>
          </div>
        </div>
        <div className="content-home">
          <div className="text-header-table">ข้อมูลใบรับเงินชั่วคราว</div>
          {listTransaction.isFetching && <LoadingOverlay />}

          <div>
            <Table
              list={listTransaction.result?.data as any[]}
              onCancel={handleModalCancel}
              itemsPerPage={itemsPerPage}
              onHandleStatus={handleConfrimStatus}
              isShowConfirmButton={loginState.account?.agentInfo.isBranchStaff as boolean}
              total={listTransaction.result?.count as number}
              onPageClick={handlePageClick}
              handleOpenTransferCompleteModal={handleOpenTransferCompleteModal}
            />
          </div>

          <CancelModal
            handleOkButton={handleCancelOkButton}
            handleCancelbutton={handleCanceldialog}
            isOpenModal={isOpenModal}
            data={cancelData}
          ></CancelModal>

          <ConfirmModal
            handleCancelbutton={handleModalConfirmCancelButton}
            isOpenModal={isOpenConfirmModal}
            data={confirmData}
          ></ConfirmModal>
          <AgingModal
            handleOkButton={handleisAgingPopupOk}
            isOpenModal={isOpenAgingPopup}
            isAccountLock={(loginState.account?.agentInfo.accountLock as boolean) || isAccountLock}
          ></AgingModal>
          <ModalTransferComplete
            isOpenModal={isOpenTransferCompleteModal}
            data={confirmData}
            handleCancelbutton={handleCloseTransferCompleteModal}
          />
        </div>
      </div>
    </div>
  )
}
